module.exports = __webpack_public_path__ + "img/email_profile_change.af075e6c.jpg";